import React, {
  FC, useEffect, useState,
} from 'react';
import { Box, Cab } from '../../../../lib/types';
import InputRoomNo from '../../Role/Driver/OpenBox/RoomNo/OpenBox';
import RoomNoOpenBoxSuccess from '../../Role/Driver/OpenBox/RoomNo/OpenBoxSuccess';
import ReopenBox from '../../Role/Driver/ReopenBox/Code/ReopenBox';
import RoomNoReopenBox from '../../Role/Driver/ReopenBox/RoomNo/ReopenBox';
import RoomNoReopenBoxSuccess from '../../Role/Driver/ReopenBox/RoomNo/ReopenBoxSuccess';

const DriverLink: FC<Props> = ({
  targetPage,
  cabId32Str,
  deviceCode,
  setTargetPage,
  isEnglish,
  setIsEnglish,
  cab,
  driverId,
  selectedPlatform,
  pickupRoomNo,
  pickupCode,
  orderId,
  setShowLoading,
  setDriverId,
  setPickupCode,
  setSelectedPlatform,
  setPickupRoomNo,
  setOrderId,
  ckFirebaseId,
  smallCabId,
  largeCabId,
  setOpenedBoxes,
  openedBoxes,
}) => {
  const [newCabIdStr, setNewCabIdStr] = useState<string>();

  useEffect(() => {
    // 不是大小柜时，设置当前柜子ID。如果是大小柜柜子，则不在这里设置柜子ID
    if (smallCabId == null || largeCabId == null) {
      setNewCabIdStr(cabId32Str);
    }
  }, []);

  // 司机输入房间号租用柜门页面
  if (targetPage === 'room-num-open-box' && newCabIdStr && selectedPlatform && driverId) {
    return (
      <InputRoomNo
        cabId32Str={newCabIdStr}
        setTargetPage={setTargetPage}
        isEnglish={isEnglish}
        setIsEnglish={setIsEnglish}
        cab={cab}
        setShowLoading={setShowLoading}
        platform={selectedPlatform}
        driverId={driverId}
        setPickupRoomNo={setPickupRoomNo}
        setOrderId={setOrderId}
        setSelectedPlatform={setSelectedPlatform}
        setOpenedBoxes={setOpenedBoxes}
      />
    );
  }

  // 司机使用房间号租用开柜成功页面
  if (targetPage === 'room-num-open-box-success' && newCabIdStr && selectedPlatform && driverId && pickupRoomNo && orderId && openedBoxes.length > 0) {
    return (
      <RoomNoOpenBoxSuccess
        cabId32Str={newCabIdStr}
        setTargetPage={setTargetPage}
        isEnglish={isEnglish}
        setIsEnglish={setIsEnglish}
        setShowLoading={setShowLoading}
        driverId={driverId}
        roomNo={pickupRoomNo}
        platform={selectedPlatform}
        orderId={orderId}
        setSelectedPlatform={setSelectedPlatform}
        setOpenedBoxes={setOpenedBoxes}
        openedBoxes={openedBoxes}
      />
    );
  }

  // 司机输入取餐码重新开柜页面
  if (targetPage === 'reopen-box' && selectedPlatform) {
    return (
      <ReopenBox
        cabId32Str={cabId32Str}
        setTargetPage={setTargetPage}
        isEnglish={isEnglish}
        setIsEnglish={setIsEnglish}
        setShowLoading={setShowLoading}
        setPickupCode={setPickupCode}
        cab={cab}
        selectedPlatform={selectedPlatform}
        setSelectedPlatform={setSelectedPlatform}
        setOpenedBoxes={setOpenedBoxes}
      />
    );
  }

  // 司机输入房间号重新开柜页面
  if (targetPage === 'room-num-reopen-box' && driverId && selectedPlatform) {
    return (
      <RoomNoReopenBox
        cabId32Str={cabId32Str}
        setTargetPage={setTargetPage}
        isEnglish={isEnglish}
        setIsEnglish={setIsEnglish}
        cab={cab}
        driverId={driverId}
        platform={selectedPlatform}
        setShowLoading={setShowLoading}
        setPickupRoomNo={setPickupRoomNo}
        setSelectedPlatform={setSelectedPlatform}
        setOpenedBoxes={setOpenedBoxes}
      />
    );
  }

  // 司机输入房间号重新开柜成功页面
  if (targetPage === 'room-num-reopen-box-success' && driverId && openedBoxes.length > 0) {
    return (
      <RoomNoReopenBoxSuccess
        cabId32Str={cabId32Str}
        setTargetPage={setTargetPage}
        isEnglish={isEnglish}
        setIsEnglish={setIsEnglish}
        driverId={driverId}
        setShowLoading={setShowLoading}
        setOpenedBoxes={setOpenedBoxes}
        setSelectedPlatform={setSelectedPlatform}
        openedBoxes={openedBoxes}
      />
    );
  }

  return <></>;
};

export interface Props {
  targetPage: string;
  cabId32Str: string;
  deviceCode: string;
  isEnglish: boolean;
  cab: Cab,
  driverId?: number;
  selectedPlatform?: number;
  pickupRoomNo?: string;
  pickupCode?: string;
  orderId?: number;
  setTargetPage: (page: string) => void;
  setIsEnglish: (isEn: boolean) => void;
  setShowLoading: (show: boolean) => void;
  setDriverId: (id: number) => void;
  setPickupCode: (code: string) => void;
  setSelectedPlatform: (platform?: number) => void;
  setPickupRoomNo: (roomNo?: string) => void;
  setOrderId: (id?: number) => void;
  ckFirebaseId?: string;
  // 大小柜组合时，小柜柜子ID和大柜柜子ID
  smallCabId?: number;
  largeCabId?: number;
  setOpenedBoxes: (openedBoxes: Box[]) => void;
  openedBoxes: Box[];
}

export default DriverLink;
